import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Helmet } from 'react-helmet'

import Header from '../components/Header'
import Layout from '../components/Layout'
import Footer from '../components/Footer'
import Steps from '../components/Steps_Gold'
import List from '../components/List'
import Features from '../components/Features'
import Title from '../components/Title'
import Intro from '../components/Intro'
import StickyBar from '../components/StickyBar'
import ContentCard from '../components/ContentCard'
import Content from '../components/Content'
import CardFlyout from '../components/CardFlyout'
import ContentApp from '../components/ContentApp'
import Break from '../components/Break'
import OnScroll from '../components/OnScroll'
import Badge from '../components/Badge'
import badgeMembership from '../images/badge_membership_15k.svg'
import Card from '../components/Card'
import Container from '../components/Container'

export const query = graphql`
  query {
    contentImage1Gold: file(relativePath: { eq: "content_01_gold.jpg" }) {
      ...contentImage
    }
    contentImage2Gold: file(relativePath: { eq: "content_02_gold.jpg" }) {
      ...contentImage
    }
    contentImage3Gold: file(relativePath: { eq: "content_03_gold.jpg" }) {
      ...contentImage
    }
    cardImageGold: file(relativePath: { eq: "card_gold.png" }) {
      childImageSharp {
        intro: fixed(width: 432) {
          ...GatsbyImageSharpFixed
        }
        small: fixed(height: 36) {
          ...GatsbyImageSharpFixed
        }
        default: fixed(width: 410) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    appMobileImageGold: file(relativePath: { eq: "app_mobile_gold.png" }) {
      childImageSharp {
        fixed(width: 360) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    walletImageGold: file(relativePath: { eq: "Wallet_Gold_wSB.png" }) {
      ...appScreenImage
    }
    appScreenImage1Gold: file(
      relativePath: { eq: "01_App_Start_Gold_wSB.png" }
    ) {
      ...appScreenImage
    }
    appScreenImage2Gold: file(
      relativePath: { eq: "02_App_Timeline_Gold_wSB.png" }
    ) {
      ...appScreenImage
    }
    appScreenImage3Gold: file(
      relativePath: { eq: "03_App_Offers_Gold_wSB.png" }
    ) {
      ...appScreenImage
    }
    appScreenImage4Gold: file(
      relativePath: { eq: "04_App_Konto_Gold_wSB.png" }
    ) {
      ...appScreenImage
    }
    introImageGold: file(relativePath: { eq: "intro_gold.jpg" }) {
      childImageSharp {
        fixed(width: 1620) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    introTabletImageGold: file(relativePath: { eq: "intro_tablet_gold.jpg" }) {
      childImageSharp {
        fixed(width: 1024) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    introMobileImageGold: file(relativePath: { eq: "intro_mobile_gold.jpg" }) {
      childImageSharp {
        fixed(width: 720) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    introPatternImageGold: file(
      relativePath: { eq: "intro_pattern_gold.png" }
    ) {
      childImageSharp {
        fixed(width: 319, height: 153) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const bodyTopHtml = `
<script
type="text/plain"
data-usercentrics="Facebook Pixel">
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window,document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '645654187336429');
  fbq('track', 'PageView');
</script>

<!-- Start of Floodlight Tag: Please do not remove Activity name of this tag: AUT_COUNTER_Gold_Card Acquisition_Retargeting_LP_Affiliate_MR_22 URL of the webpage where the tag is expected to be placed: https://www.amex-card.at/gold-mr-aff This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag. Creation Date: 03/30/2022 -->
<div id="floodlight"></div>
<script type="text/plain" data-usercentrics="DoubleClick Floodlight">
var axel = Math.random() + "";
var a = axel * 10000000000000;
var html = '<iframe src="https://3863644.fls.doubleclick.net/activityi;src=3863644;type=amexg024;cat=aut_c004;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${'{GDPR}'};gdpr_consent=${'{GDPR_CONSENT_755}'};ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>'
document.getElementById("floodlight").innerHTML = html;
</script>
<!-- End of Floodlight Tag: Please do not remove -->

<script
type="text/plain"
data-usercentrics="LinkedIn Ads">
  _linkedin_partner_id = "4389073";
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id);
</script>
<script
type="text/plain"
data-usercentrics="LinkedIn Ads">
  (function(l) { if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; window.lintrk.q=[]} var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})(window.lintrk);
</script>
`

const euLocale = `
  window.euLocale = 'AT_de';
`

const variant = 'gold-aff'

const theme = {
  name: 'gold',
}
const GoldPage = ({ data }) => (
  <Layout theme={theme}>
    <Helmet>
      <script 
	  		src="https://www.amex-card.at/usercentrics/usercentrics.js" async>
	    </script>
	  	<script
          id="usercentrics-cmp"
          src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
          data-settings-id="gfdjO6gCP4ExFC" async></script>
      <script type="application/javascript">{`${euLocale}`}</script>
      <script
        type="text/plain"
        data-usercentrics="Adobe Analytics"
        src="https://www.americanexpress.com/adobedtm-acq"></script>
      <meta
        name="facebook-domain-verification"
        content="qshmf9bovobkq3fy7m7rrvqil6y2s5" />
    </Helmet>
    <div
      style={{ width: 0, height: 0, overflow: 'hidden' }}
      dangerouslySetInnerHTML={{ __html: bodyTopHtml }}
    />
    <Header
      currentCard="gold"
      currentVariant={variant}
      disableCompare={true}
      disableGreen={true}
disableBlue={true}
      cardLinks={{
        blue: '/blue-aff',
        green: '/green-aff',
        gold: '/gold-aff',
        platinum: '/platinum-aff',
      }}
    />

    <Intro
      variant={variant}
      theme={theme}
      title={
        <>
          Die Gold Card von
          <br />
          American Express
        </>
      }
      text={
        <List color="white" bold900>
          <List.Item>
            15.000 Membership Rewards® Punkte<sup>1)</sup>
          </List.Item>
          <List.Item>
            Top-Reiseversicherungen inklusive<sup>2)</sup>
          </List.Item>
 <List.Item>
            Nur 16 Euro monatlich
          </List.Item>
        </List>
      }
      textWide={true}
      mobileText={
        <List bold900>
          <List.Item>
            15.000 Membership Rewards® Punkte<sup>1)</sup>
          </List.Item>
          <List.Item>
            Top-Reiseversicherungen inklusive<sup>2)</sup>
          </List.Item>
  		  <List.Item>
            Nur 16 Euro monatlich
          </List.Item>
		  <List.Item>
            2 Zusatzkarten kostenfrei<sup>3)</sup>
          </List.Item>
        </List>
      }
      infoTitle={
        <>
          15.000 Membership Rewards® Punkte<sup>1)</sup>
        </>
      }
      infoMeta={
        <>
          + 2 Zusatzkarten kostenfrei<sup>3)</sup>
        </>
      }
      image={data.introImageGold.childImageSharp.fixed}
      tabletImage={data.introTabletImageGold.childImageSharp.fixed}
      mobileImage={data.introMobileImageGold.childImageSharp.fixed}
      patternImage={data.introPatternImageGold.childImageSharp.fixed}
      cardImage={data.cardImageGold.childImageSharp.intro}
      cardsFlyout={[
        data.cardImageGold.childImageSharp.default,
        data.cardImageGold.childImageSharp.default,
      ]}
      cardsFlyoutNumber={2}
    />

    <StickyBar
      variant={variant}
      card={data.cardImageGold.childImageSharp.small}
      title="Die Gold Card"
      mobileSubline={
        <>
          + 15.000 Membership Rewards® Punkte<sup>1)</sup>
        </>
      }
      content={
        <List small inline bold900>
          <List.Item>
            15.000 Membership Rewards® Punkte<sup>1)</sup>
          </List.Item>
          <List.Item>
            Top-Reiseversicherungen inklusive<sup>2)</sup>
          </List.Item>
        </List>
      }
      spaceEvenly={true}
    />

    <Content
      reverse
      image={
        <Img
          fluid={data.contentImage1Gold.childImageSharp.fluid}
          style={{ display: 'block' }}
          imgStyle={{ display: 'block' }}
          quality={100}
        />
      }>
      <Title margin>Rundum sicher.</Title>
      Mit der Gold Card können Sie entspannt Ihre Reise starten.
      <br />
      <br />
      <List bold>
        <List.Item>
          Reiserücktritts- und Reiseabbruchkostenversicherung
        </List.Item>
        <List.Item>Auslandsreise-Krankenversicherung</List.Item>
        <List.Item>Auslandsreise-Privathaftpflicht-Versicherung</List.Item>
        <List.Item>24-Stunden-Kundenservice</List.Item>
        <List.Item>Soforthilfe bei Notfällen im Ausland</List.Item>
        <List.Item>
          Return Protection (90-tägiges On- und Offline Rückgaberecht)
        </List.Item>
        <List.Item>Reisegepäck-Versicherung</List.Item>
        <List.Item>Reise-Unfallversicherung</List.Item>
      </List>
    </Content>

    <Break />
    <Break />
    <Break />
    <Break />
    <Break desktop />
    <Break Desktop />

    <Content
      background
      image={
        <Img
          fluid={data.contentImage2Gold.childImageSharp.fluid}
          style={{ display: 'block' }}
          imgStyle={{ display: 'block' }}
          quality={100}
        />
      }>
      <Title margin>Ihr Membership Rewards® Programm</Title>
      Mit der American Express Gold Card nehmen Sie automatisch an unserem Membership Rewards® Programm teil:
      <br />
      <br />
      <List bold>
        <List.Item>1 Euro = 1 Membership Rewards® Punkt</List.Item>
        <List.Item>Mit jedem Einsatz Punkte sammeln</List.Item>
        <List.Item>Rechnungen schrumpfen lassen</List.Item>
        <List.Item>ExtraPunkte sammeln durch Weiterempfehlungen</List.Item>
      </List>
      <br />
      Ihren Möglichkeiten sind kaum Grenzen gesetzt.
    </Content>

    <ContentCard
      boxOneTitle="75 Euro Startguthaben"
      boxOneText={
        <>
          Zum Start bekommen Sie 15.000 Membership Rewards® Punkte im Wert von 75 Euro geschenkt.<sup>1)</sup> Schon ab einem Kartenumsatz von nur 1.000 Euro innerhalb der ersten 3 Monate nach Kartenerhalt sind Ihnen Ihre Willkommenspunkte sicher.
          <br />
          <br />
          Die Gold Card kostet nur 16 Euro pro Monat. Sie können die Gebühr mit Ihren Membership Rewards® Punkten begleichen.
        </>
      }
      boxTwoTitle="Einfach. Sicher. Kontaktlos."
      boxTwoText={
        <>
          Zahlen Sie mit der Gold Card schnell und bequem mit nur einer Handbewegung. Bei Beträgen unter 50 Euro geht das sogar ohne PIN. Halten Sie dafür einfach Ihre American Express Karte an das Zahlungsterminal. <br /><br /><br />
        </>
      }

	  boxTwoTitleTWO="Mehr Akzeptanz."
      boxTwoTextTWO={
        <>
          Die Gold Card ist von A wie Austrian Airlines bis Z wie Zalando weltweit bei über 66 Millionen Akzeptanzstellen willkommen. Darüber hinaus können Sie in nahezu allen großen Supermärkten, Lebensmitteldiscountern, Drogerien und Tankstellen mit Ihrer Gold Card zahlen und Membership Rewards® Punkte sammeln. Auch beim Italiener um die Ecke.
        </>
      }
      card={data.cardImageGold.childImageSharp.intro}
    />

    <Break />
    <Break />
    <Break />
    <Break desktop />
    <Break desktop />
    <Break desktop />

    <ContentApp
      title={
        <>
          Amex App: Konto&shy;verwaltung
          <br /> kann so einfach sein.
        </>
      }
      text={
        <p>
         Mit der American Express® App nehmen Sie Ihr Konto überall mit hin. Aktivieren Sie Ihre Gold Card, verwalten Sie Kontobewegungen, Kontodaten, Membership Rewards® Punkte und noch vieles mehr. Einfache Anmeldung mit Touch ID und Face ID (unterstützte Geräte vorausgesetzt).
        </p>
      }
      mobileImage={data.appMobileImageGold}
      walletImage={data.walletImageGold.childImageSharp.fixed}
      appImages={[
        data.appScreenImage1Gold.childImageSharp.fixed,
        data.appScreenImage2Gold.childImageSharp.fixed,
        data.appScreenImage3Gold.childImageSharp.fixed,
        data.appScreenImage4Gold.childImageSharp.fixed,
      ]}
    />

    <br />
    <br />
    <Break desktop />
    <Break desktop />
    <Break desktop />

    <Container>
      <Card
        image={data.cardImageGold.childImageSharp.intro}
        indentBottom
        mobileMaxWidth={'80%'}
      />
    </Container>

    <Features variant={variant} title={<>Service und Reisen</>}>
      <List>
        <List.Item>
          <strong>24-Stunden-Kundenservice</strong>
        </List.Item>
        <List.Item>
          Kontoübersicht durch Online-Kartenkonto und Amex App
        </List.Item>
        <List.Item>
          Sicher shoppen dank <strong>American Express SafeKey®</strong>
        </List.Item>
        <List.Item>PIN frei wählbar bei Online-Beantragungen</List.Item>
        <List.Item>
          <strong>Flexibles Ausgabenlimit</strong> im Rahmen Ihrer finanziellen Möglichkeiten
        </List.Item>
        <List.Item>
          NFC – <strong>kontaktloses Bezahlen</strong>
        </List.Item>
        <List.Item>
          Zugang zu den <strong>Airport-Lounges</strong> am Wiener Flughafen
        </List.Item>
        <List.Item>
          Umfangreiches Reiseversicherungspaket (auch für die Zusatzkarten)
        </List.Item>
      </List>
    </Features>

    <Badge
      alt={'15.000 Membership Rewards® Punkte'}
      width={'260'}
      badge={badgeMembership}
    />

    <Break mobile />

    <OnScroll>
      {inViewport => (
        <CardFlyout
          card={data.cardImageGold.childImageSharp.default}
          transparent
          expanded={inViewport}
          cardFlyoutNumber={2}
        />
      )}
    </OnScroll>

    <br />
    <br />

    <Steps
      variant={variant}
      title={
        <>
          Die Gold Card inkl. 2 kostenfreien Zusatzkarten.<sup>3)</sup>
          <br /> <Steps.Space>Jetzt beantragen in nur 3 Schritten.</Steps.Space>
        </>
      }
      step1="Gold Card beantragen"
      step2="Kopie eines Lichtbildausweises sowie Kopie der Bankomatkarte oder eines aktuellen (Online-) Kontoauszuges übermitteln"
    />

    <br />
    <br />
    <br />

    <Footer>
      <p>
        <sup>1)</sup> Sie erhalten nach Kartenerhalt und Belastungen von mindestens 1.000 Euro (unter Ausschluss von Bargeldauszahlungen und nach Abzug von etwaigen Gutschriften von Vertragspartner:innen) innerhalb der ersten 3 Monate mit Ihrer Karte eine Gutschrift von 15.000 Membership Rewards, wenn Sie am Membership Rewards Programm teilnehmen. 15.000 Punkte entsprechen zum Beispiel einem Amazon.at Gutschein im Wert von 75 Euro. Anspruch auf die Gutschrift haben nur Antragsteller:innen, die innerhalb der letzten 18 Monate nicht als Hauptkarteninhaber:in einer österreichischen American Express Gold Card registriert waren. Die Gutschrift kann nicht ausgezahlt werden, sondern kann nur mit weiteren Kartenbelastungen verrechnet werden. Im Falle einer Kartenkündigung innerhalb der ersten 12 Monate erlischt der Anspruch auf den Willkommensbonus.
      </p>
      <p>
        <sup>2)</sup> Alle Details zu den Leistungen und Versicherungen finden
        Sie{' '}
        <a
          href="https://www.americanexpress.com/at/legal/terms-and-conditions/"
          target="_blank"
          rel="noopener noreferrer">
          hier
        </a>
        .
      </p>
      <p>
        <sup>3)</sup> Der Gegenwert der Zusatzkarte wird nicht ausgezahlt bzw. nicht dem Kartenkonto gutgeschrieben, falls die Zusatzkarte nicht in Anspruch genommen wird.
      </p>
      <p>
        Alle detaillierten Informationen zu Schutz und Sicherheit finden Sie{' '}
        <a
          href="https://www.americanexpress.com/at/vorteile/service-sicherheit/betrugsschutz/"
          target="_blank"
          rel="noopener noreferrer">
          hier
        </a>
        .
      </p>
    </Footer>
</Layout>
)

export default GoldPage
